import { useEffect } from "react";
import { toast } from "sonner";
import { getLoadId } from "@/utils/load";

// Shared ref for previous offers state
const prevQuotesRef = { current: [] };
const prevBookingsRef = { current: [] };

export const updatePrevOffers = (quotes, bookings) => {
  prevQuotesRef.current = quotes || [];
  prevBookingsRef.current = bookings || [];
};

export const useOfferStatusNotifications = (quotes, bookings) => {
  useEffect(() => {
    const prevQuotes = prevQuotesRef.current;
    const currentQuotes = quotes || [];

    if (prevQuotes.length === 0) {
      prevQuotesRef.current = currentQuotes;
      return;
    }

    const prevQuotesMap = new Map(prevQuotes.map((q) => [q.id, q]));

    currentQuotes.forEach((quote) => {
      const prevQuote = prevQuotesMap.get(quote.id);
      if (prevQuote && prevQuote.status !== "ACCEPTED" && quote.status === "ACCEPTED") {
        const loadId = getLoadId(quote.loadBoardItem.uniqueId);
        toast.success(`Broker has accepted Load ${loadId} offer!`);
      }
    });

    // Check for newly declined quotes (exclude CANCELLED as it's user-initiated)
    currentQuotes.forEach((quote) => {
      const prevQuote = prevQuotesMap.get(quote.id);
      if (prevQuote && !["DECLINED", "EXPIRED"].includes(prevQuote.status) && ["DECLINED", "EXPIRED"].includes(quote.status)) {
        const loadId = getLoadId(quote.loadBoardItem.uniqueId);
        toast.error(`Broker has declined Load ${loadId} offer!`);
      }
    });

    prevQuotesRef.current = currentQuotes;
  }, [quotes]);

  useEffect(() => {
    const prevBookings = prevBookingsRef.current;
    const currentBookings = bookings || [];

    if (prevBookings.length === 0) {
      prevBookingsRef.current = currentBookings;
      return;
    }

    const prevBookingsMap = new Map(prevBookings.map((b) => [b.id, b]));

    // Check for newly confirmed bookings
    currentBookings.forEach((booking) => {
      const prevBooking = prevBookingsMap.get(booking.id);
      if (prevBooking?.status !== "CONFIRMED" && booking.status === "CONFIRMED") {
        const loadId = getLoadId(booking.loadBoardItem.uniqueId);
        toast.success(`Broker has accepted Load ${loadId} offer!`);
      }
    });

    // Check for newly rejected bookings (exclude CANCELLED as it's user-initiated)
    currentBookings.forEach((booking) => {
      const prevBooking = prevBookingsMap.get(booking.id);
      if (prevBooking?.status !== "REJECTED" && booking.status === "REJECTED") {
        const loadId = getLoadId(booking.loadBoardItem.uniqueId);
        toast.error(`Broker has declined Load ${loadId} offer!`);
      }
    });

    prevBookingsRef.current = currentBookings;
  }, [bookings]);
};
